import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { SessionProvider } from './context/SessionContext';
import { ThemeProvider } from './context/ThemeContext';
import { ModalProvider } from './components/ModalProvider';
import { ErrorBoundary } from './components/ErrorBoundary';
import './styles.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <ThemeProvider>
        <SessionProvider>
          <ModalProvider>
            <div id="app">
              <App />
            </div>
          </ModalProvider>
        </SessionProvider>
      </ThemeProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);
